/* ====== STICKY CART ====== */
// var scrollY = 0;

function isElementInViewport(element) {
  var elementRect = element.getBoundingClientRect();
  var top = elementRect.top;
  var bottom = elementRect.bottom;
  var left = elementRect.left;
  var right = elementRect.right;
  var viewportHeight = window.innerHeight;
  var viewportWidth = window.innerWidth;
  return (top >= 0 && bottom <= viewportHeight && left >= 0 && right <= viewportWidth);
}
function checkSticky(){
  // console.log('checkSticky');
  // console.log(`${scrollY} < ${($(element).offset().top)} : ${$(element).offset().top}`)
  // console.log((scrollY < ($(element).offset().top)));
  if ((scrollY < ($(element).offset().top + $(element).height()))) {
    // Element is in viewport
      $('#crisp-chatbox').removeClass('pm-active');
    if(!$('.sticky-atc_wrapper').hasClass('untoggle')){
      $('.sticky-atc_wrapper').addClass('untoggle');
    
    }
  } else {
    // Element is not in viewport
       $('#crisp-chatbox').addClass('pm-active');
    if($('.sticky-atc_wrapper').hasClass('untoggle')){
      $('.sticky-atc_wrapper').removeClass('untoggle');
      
    }
  
  }
}

var element = document.querySelector('.purchase-details__buttons');
var refreshP = setInterval(function(){
  if($(element).length > 0){
    checkSticky(element);
    clearInterval(refreshP);
  }
},1000); 

var chatEl = document.querySelector('#crisp-chatbox');
var refreshC = setInterval(function(){
  chatEl = document.querySelector('#crisp-chatbox');
  if($(chatEl).length > 0){
    checkSticky(element);
    // console.log('refreshC');
    // clearInterval(refreshC);
  }
},100); 

window.addEventListener('scroll', function() {
   // scrollY = this.scrollY;
   // console.log(this.scrollY)
   checkSticky(element);
});
window.addEventListener("resize", function() {
  checkSticky(element);
});



$(document).on('click','.sticky-atc_wrapper [data-sticky-add]',function(){
  console.log('click');
  $('.purchase-details .button--add-to-cart').click();
  $('html,body').animate({ scrollTop: 0 }, 'slow');
});
$('.sticky-atc_wrapper [data-sticky-conf]').on('click',function(){
  console.log('click');
  $('html,body').animate({ scrollTop: ($('.shopify-product-form').offset().top - 100) }, 'slow');
});
// Synchrnize two quantity inputs
$(".sticky-atc_wrapper .quantity-input").on("input", function() {
  $("form .quantity-input").val(this.value);
});
// $('variant-selection').children().length;
document.addEventListener('DOMContentLoaded',function() {  
  var refreshBoldOptions = setInterval(function(){
      if($('.bold_options_loaded').length > 0){
        if($('.bold_options_loaded').children().length > 0){
          console.log('bold_options_loaded');
          $('.sticky-atc_wrapper [data-sticky-add]').hide();
          $('.sticky-atc_wrapper [data-sticky-conf]').show();
            clearInterval(refreshBoldOptions);
        }
      
      }
  },10);
});
/* ====== STICKY CART ====== */